import { Fragment, useEffect, useState } from 'react';
import { Alert } from '../../../../core/components/atoms/Alert';
import { Icon } from '../../../../core/components/atoms/Icon';
import { Tag } from '../../../../core/components/atoms/Tag';
import PageHeader from '../../../../core/components/molecules/Header';
import { Typography } from '../../../../core/components/molecules/Typography';
import { useCredits } from '../../hooks/useCredits';
import { meEssayStore } from '../../stores/meEssayStore';
import { add, endOfMonth, format } from 'date-fns';

export default function WritingHeader({ theme }: { theme?: string }) {
  const { isPending } = useCredits();
  const { credits } = meEssayStore();

  const [renovationDay, setRenovationDay] = useState<string>('');

  const mountCredit = () => {
    const credit =
      isPending || !credits || !credits.remainingCreditsMonth
        ? 0
        : credits?.remainingCreditsMonth;
    let string = 'crédito';

    if (credit !== 1) {
      string = 'créditos';
    }

    return `${credit} ${string}`;
  };

  useEffect(() => {
    if (
      credits &&
      (!credits.remainingCreditsMonth || credits?.remainingCreditsMonth < 1)
    ) {
      const date = endOfMonth(new Date());
      const added = add(date, { days: 1 });
      const formated = format(added, 'dd/MM/yyyy');

      setRenovationDay(formated);
    }
  }, [credits]);

  return (
    <Fragment>
      <div className='flex xs:flex-col xs:items-start xs:gap-xs lg:flex-row lg:items-center lg:gap-xxxl'>
        <div className='flex-1'>
          <PageHeader module='Redação' title={theme || ''} />
        </div>
        <div className='flex w-fit flex-col'>
          <Tag
            variant='neutral'
            className={`
              flex w-fit flex-row items-center gap-xs px-3 py-[3px] 
              ${
                !credits?.remainingCreditsMonth ||
                credits.remainingCreditsMonth === 0
                  ? 'border-hairline border-warning-500 bg-warning-100'
                  : 'bg-mono-color-white'
              }
            `}
          >
            <Icon type='material' Icon='folder' className='text-md' />
            <Typography className='xs:text-sm md:text-md'>
              {mountCredit()}
            </Typography>
          </Tag>
        </div>
      </div>
      {(!credits?.remainingCreditsMonth ||
        credits.remainingCreditsMonth === 0) && (
        <Alert
          variant='warning'
          message={
            <Typography>
              <b>Atenção:</b> Você não possui créditos disponíveis para enviar
              sua redação.
              <b> Seus créditos serão renovados no dia {renovationDay}.</b>
            </Typography>
          }
        />
      )}
    </Fragment>
  );
}
